const cartActionTypes = {
    TOGGLE_CART_HIDDEN: "TOGGLE_CART_HIDDEN",
    ADD_ITEM: "ADD_ITEM",
    REMOVE_ITEM: "REMOVE_ITEM",
    CLEAR_ITEM: "CLEAR_ITEM",
    CLEAR_CART: "CLEAR_CART"
}
export default cartActionTypes